import React from "react"
const AddIcon = ({ className }) => {
  return (
    <svg
      viewBox="0 0 23 23"
      className={className}
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.375 10.375V5.875H12.625V10.375H17.125V12.625H12.625V17.125H10.375V12.625H5.875V10.375H10.375ZM11.5 22.75C5.28663 22.75 0.25 17.7134 0.25 11.5C0.25 5.28663 5.28663 0.25 11.5 0.25C17.7134 0.25 22.75 5.28663 22.75 11.5C22.75 17.7134 17.7134 22.75 11.5 22.75ZM11.5 20.5C13.8869 20.5 16.1761 19.5518 17.864 17.864C19.5518 16.1761 20.5 13.8869 20.5 11.5C20.5 9.11305 19.5518 6.82387 17.864 5.13604C16.1761 3.44821 13.8869 2.5 11.5 2.5C9.11305 2.5 6.82387 3.44821 5.13604 5.13604C3.44821 6.82387 2.5 9.11305 2.5 11.5C2.5 13.8869 3.44821 16.1761 5.13604 17.864C6.82387 19.5518 9.11305 20.5 11.5 20.5Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default AddIcon
